module.exports = __webpack_public_path__ + "static/media/også.a8693c21.mp3";